<template>
	<div class="pb-3">
		<div class="school-container flex flex-col justify-center items-center relative h-full">
			<base-map :items="schools" @itemClicked="setSchool" class="school-search--map-home w-full h-full rounded-3xl"></base-map>
			<info-vue class="p-5 lg:block hidden" :schoolSelected="schoolSelected" :isOpen="isOpen"></info-vue>
		</div>
		<info-vue :on-promo="onPromo" class="lg:hidden" :schoolSelected="schoolSelected" :isOpen="isOpen" :dark-theme="darkTheme"></info-vue>
	</div>
</template>

<script>
import InfoVue from "./Info.vue";
export default {
    props: {
        schools: {
            type: Array
        },
        onPromo: {
            type: Boolean,
            default: false
        },
        darkTheme: {
            type: Boolean,
            default: false
        }
    },
	components: {
		InfoVue
	},
	data() {
		return {
			schoolSelected: this.schools[0],
			isOpen: true
		};
	},
	methods: {
		setSchool(school) {
			this.schoolSelected = {};
			this.schoolSelected = { ...school };
		}
	},
	computed: {
		mapZoom() {
			if (this.schools.length === 1) return 16;
			if (window.innerWidth >= 768) return 8;
			return 7;
		},
		centerCoordinates() {
			if (this.schools.length === 1)
				return {
					lat: this.schools[0].latitude,
					lng: this.schools[0].longitude
				};
			return {
				lat: 41.95,
				lng: 1.566979
			};
		}
	}
};
</script>

<style lang="scss">
.school-search--map-home {
	height: 28rem;

	@media (max-width: 1024px) {
		height: 30rem;
	}
}
</style>
